<div class="w-100 d-flex justify-content-center align-items-center gap-3 p-3">
	@for (destination of destinations(); track destination.id) {
		<button
			class="btn btn-danger text-small"
			[disabled]="!vehicleInUseSelected()"
			(click)="selectDestination(destination.id)"
		>
			{{ destination.address }}
		</button>
	}
</div>
